module.exports = __webpack_public_path__ + "assets/img/shifu.271a54b5.png";